











import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import Footer from '@/components/Footer.vue'
import Menu from '@/components/Menu.vue'

// In "data" I store the [array] with date {objects} which have an [array] of events sorted by starting time. 
// In "time" I make a moment.js object Moment to save the current time and compare it to the event entries later.
// "newRandom" is a counter with which an event is emmitted in Random.vue to pick a new event.
// In the mounted cycle axios fetches the data from the API.

export default Vue.extend({
  name: 'App',
  components: {
    Menu, Footer
  },
  data() {
    return {
      events: [],
      time: moment().format('YYYYMMDDHHmm'),
      newRandom: 0,
      about: null
    }
  },
  mounted() {
    var self = this;
    axios
    .get('https://newaex.com/admin/wp-json/api/main')
    .then(response => {
      self.events = response.data.events;
      self.about = response.data.about;
    })
    .catch(error => {
      console.log(error)
    })
    setInterval(() => {
      this.time = moment().format('YYYYMMDDHHmm')
    }, 1000);
  },
  methods: {
    newRandomClick: function() {
      this.newRandom += 1;
    }
  }
});
